import { OnboardingOptionPill } from "@/features/onboarding/components/onboarding-option-pill";
import { OnboardingPillButton } from "@/features/onboarding/components/onboarding-pill-button";
import { OnboardingStepShellV5 } from "@/features/onboarding/components/onboarding-step-shell-v5";
import { useGetFitnessProfile } from "@/hooks/requests/fitness-profile/use-get-fitness-profile";
import { useUpdateFitnessProfile } from "@/hooks/requests/fitness-profile/use-update-fitness-profile";
import { useToast } from "@/hooks/ui/use-toast";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { triggerHaptic } from "@/utils/haptics";
import { useEffect, useRef, useState } from "react";

const OPTIONS = [
  { id: "0", label: "0" },
  { id: "1-2", label: "1 – 2" },
  { id: "3-4", label: "3 – 4" },
  { id: "5-plus", label: "5 or more" },
];

const WorkoutsPage = () => {
  const { navigateToNextStep, preloadNextRoute } = useStepRouteInfo();
  const { fitnessProfile } = useGetFitnessProfile();
  const { updateFitnessProfileAsync, isUpdating } = useUpdateFitnessProfile();
  const { showError } = useToast();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const hydratedRef = useRef(false);

  useEffect(() => {
    if (hydratedRef.current) return;
    if (fitnessProfile?.workoutsPerWeek) {
      setSelectedId(fitnessProfile.workoutsPerWeek);
      hydratedRef.current = true;
    }
  }, [fitnessProfile?.workoutsPerWeek]);

  const handleContinue = async () => {
    if (!selectedId || isUpdating) return;
    triggerHaptic();
    try {
      // Only this screen's field — PUT merges, so the other answers are preserved.
      await Promise.all([
        preloadNextRoute(),
        updateFitnessProfileAsync({ workoutsPerWeek: selectedId }),
      ]);
      navigateToNextStep();
    } catch (error) {
      showError(error instanceof Error ? error.message : "An unexpected error occurred");
    }
  };

  return (
    <OnboardingStepShellV5
      title="How many workouts do you usually do each week?"
      footer={
        <OnboardingPillButton
          text="Continue"
          onClick={handleContinue}
          disabled={!selectedId || isUpdating}
        />
      }
    >
      <div className="flex flex-col gap-4">
        {OPTIONS.map((option) => (
          <OnboardingOptionPill
            key={option.id}
            label={option.label}
            selected={selectedId === option.id}
            onClick={() => setSelectedId(option.id)}
          />
        ))}
      </div>
    </OnboardingStepShellV5>
  );
};

export default WorkoutsPage;
